exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.choice-radio[data-v-1ebf0506]{padding:10px 0;background-color:#fff;color:#0c2340;cursor:pointer}div.column[data-v-1ebf0506]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}span.name[data-v-1ebf0506]{cursor:pointer}", ""]);

// exports
